import axios from 'axios';

export async function getWeatherExport(
  locationId: number,
  fromTime: string,
  toTime: string
): Promise<Blob> {
  const url = `/api/weather/${locationId}/history-export/${fromTime}/${toTime}`;
  try {
    const { data } = await axios.get(url, { responseType: 'blob' });
    return data as Blob;
  } catch (err) {
    throw err;
  }
}
